import { useState } from 'react';

export function useDialogState<T = any>() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<T | undefined>();

  const open = (item?: T) => {
    setData(item);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setData(undefined);
  };

  return {
    isOpen,
    data,
    open,
    close,
    isEditing: !!data,
  };
}
